'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var reactI18next = require('react-i18next');
var useDefaultInternalState = require('../../hooks/useDefaultInternalState.js');
var Input = require('./Input.js');
var Validator = require('./Validator.js');

var SerialInput = function (_a) {
    var _b = _a.id, id = _b === void 0 ? 'serialInput' : _b, label = _a.label, onChange = _a.onChange, onBlur = _a.onBlur, _c = _a.hideLabel, hideLabel = _c === void 0 ? false : _c, _d = _a.value, value = _d === void 0 ? '' : _d, setValue = _a.setValue, error = _a.error, setError = _a.setError, _e = _a.disableInternalValidation, disableInternalValidation = _e === void 0 ? false : _e, props = tslib.__rest(_a, ["id", "label", "onChange", "onBlur", "hideLabel", "value", "setValue", "error", "setError", "disableInternalValidation"]);
    var t = reactI18next.useTranslation()[0];
    var _f = useDefaultInternalState.default(value, setValue), valueState = _f[0], setValueState = _f[1];
    var _g = useDefaultInternalState.default(error, setError), errorState = _g[0], setErrorState = _g[1];
    var MAX_LENGTH = 8;
    var INVALID_SERIAL_MSG = t('SN_NUMBER_ERROR_EXPLAIN');
    var repeatValue = function (num, val) {
        var s = '';
        for (var i = 0; i < num; i++) {
            s = s + val;
        }
        return s;
    };
    var enforceSerialFormat = function (e) {
        var newValue = e.target.value;
        if (newValue.length < MAX_LENGTH && newValue.substr(3).match('^[0-9]+$')) {
            var lastPart = newValue.substr(3);
            var numberOfZeros = MAX_LENGTH - newValue.length;
            var threeChar = newValue.substr(0, 3);
            setValueState("".concat(threeChar).concat(repeatValue(numberOfZeros, '0')).concat(lastPart));
        }
        onBlur && onBlur(e);
    };
    var validator = function (currentValue) {
        // TODO: need to fix after validator is typed.
        return new Validator.default(currentValue)
            .isValidSerialNumber(INVALID_SERIAL_MSG)
            .getError();
    };
    var enforceSerialOnEnter = function (e) {
        if (e.key === 'Enter') {
            enforceSerialFormat(e);
        }
    };
    return (jsxRuntime.jsx(Input.default, tslib.__assign({ label: (label || t('CAT_ORDER_SERIAL_NO')), hideLabel: hideLabel, onBlur: enforceSerialFormat, onChange: onChange, validator: disableInternalValidation ? null : validator, value: valueState, setValue: setValueState, id: id, error: errorState, onKeyPress: enforceSerialOnEnter, setError: setErrorState, maxLength: "8" }, props)));
};
var SerialInput$1 = SerialInput;

exports.default = SerialInput$1;
//# sourceMappingURL=SerialInput.js.map
